/**
 * League types users can create from the Create League modal (includes full H2H fields).
 */
export const LEAGUE_CREATION_ALLOWED_TYPES = ['pickem', 'budget_league', 'h2h'] as const;

export type LeagueCreationAllowedType = (typeof LEAGUE_CREATION_ALLOWED_TYPES)[number];

/**
 * Standalone /create-league page: no H2H-specific form, so H2H is not offered there (use Live Tournaments + modal).
 */
export const LEAGUE_CREATION_STANDALONE_PAGE_TYPES = ['pickem', 'budget_league'] as const;

export function isLeagueCreationAllowed(leagueType: string): boolean {
  return (LEAGUE_CREATION_ALLOWED_TYPES as readonly string[]).includes(leagueType);
}

export function isLeagueCreationAllowedOnStandalonePage(leagueType: string): boolean {
  return (LEAGUE_CREATION_STANDALONE_PAGE_TYPES as readonly string[]).includes(leagueType);
}
